var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.334 158.333V62.9085C183.334 50.8763 183.334 44.8602 181.306 40.1372C178.778 34.2487 174.085 29.5558 168.197 27.0277C163.474 25 157.517 25 145.425 25H141.308C136.266 25 131.494 27.2828 128.331 31.2091L113.188 50M113.188 50H66.6673C54.9998 50 49.1657 50 44.709 52.2707C40.789 54.2681 37.6023 57.4552 35.6048 61.3752C33.334 65.8317 33.334 71.6656 33.334 83.3333V91.6667M113.188 50H141.667",
    stroke: "#E5E5E5",
    strokeWidth: 12.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.684 129.286L171.197 123.097C165.082 107.874 162.024 100.263 155.647 95.9648C149.271 91.6665 141.038 91.6665 124.571 91.6665H57.4015C34.9973 91.6665 23.7956 91.6665 18.8157 98.989C13.8365 106.312 17.9965 116.668 26.3173 137.38L28.804 143.569C34.9198 158.792 37.9773 166.403 44.354 170.701C50.7306 175 58.964 175 75.4307 175H142.6C165.004 175 176.206 175 181.185 167.677C186.165 160.354 182.005 149.998 173.684 129.286Z",
    stroke: "#E5E5E5",
    strokeWidth: 12.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/empty_list.a26278cfd12f653fd91ea3f0e1fe1ec1.svg";
export { ForwardRef as ReactComponent };